import { createRouter, createWebHistory } from 'vue-router'
import EventList from '@/views/EventList.vue'
import RehabList from '@/views/RehabList.vue'
import EventDetails from '@/views/EventDetails.vue'
import EventCreate from '@/views/EventCreate.vue'
import ErrorDisplay from '@/views/ErrorDisplay.vue'
import About from '@/views/About.vue'

const routes = [
  {
    path: '/eventlist',
    name: 'EventList',
    component: EventList
  },
  {
    path: '/',
    name: 'RehabList',
    component: RehabList
  },
  {
    path: '/event/:id',
    name: 'EventDetails',
    props: true,
    component: EventDetails
  },
  {
    path: '/event/create',
    name: 'EventCreate',
    component: EventCreate
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/error/:error',
    name: 'ErrorDisplay',
    props: true,
    component: ErrorDisplay
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router